import styled from 'styled-components';

export const AdminScanActivityContainerStyled = styled.div`
  padding: 60px 16px 104px 16px;
`;
